import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { HotelRateWarningCard } from './ui/hotel_rate_warning.js';

export { HotelRateWarningCard } from './ui/hotel_rate_warning.js';

export const hotelRateWarningEntry: GenUiEntry<Extract<ChatUi, { kind: 'hotel_rate_warning' }>> = {
  kind: 'hotel_rate_warning',
  slot: 'chat',
  policy: { productOf: () => 'hotel' },
  render: ({ ui, readOnly, dispatch }) => (
    <HotelRateWarningCard warning={ui.warning} readOnly={readOnly} dispatch={dispatch} />
  ),
};
